import { render } from "./SingleDaySlide.vue?vue&type=template&id=25266ea4&scoped=true"
import script from "./SingleDaySlide.vue?vue&type=script&lang=js"
export * from "./SingleDaySlide.vue?vue&type=script&lang=js"

import "./SingleDaySlide.vue?vue&type=style&index=0&id=25266ea4&scoped=true&lang=css"
import "./SingleDaySlide.vue?vue&type=style&index=1&id=25266ea4&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25266ea4"]])

export default __exports__